<script lang="ts">
    // Mirrors EventConfirmation: centered success, summary + thank-you cards, calendar dropdown, share, nav.
</script>

<div
    class="confirmation-shell max-w-3xl mx-auto px-4 md:px-6 py-8 flex flex-col items-center text-center animate-pulse"
    data-testid="event-confirmation-skeleton-loader"
>
    <div class="w-24 h-24 bg-gray-300 rounded-full mb-6" />

    <div class="h-10 w-56 max-w-full bg-gray-300 rounded mb-8" />

    <!-- Event summary card -->
    <div class="w-full max-w-xl bg-gray-100 border border-gray-200 rounded-xl p-5 mb-8">
        <div class="h-6 w-4/5 max-w-md bg-gray-300 rounded mx-auto mb-3" />
        <div class="h-4 w-3/5 max-w-sm bg-gray-200 rounded mx-auto" />
    </div>

    <!-- Thank-you message card -->
    <div class="w-full max-w-xl bg-white border border-gray-200 rounded-xl p-5 mb-8">
        <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-full" />
            <div class="h-4 bg-gray-200 rounded w-4/5 mx-auto" />
        </div>
    </div>

    <!-- Add to Calendar dropdown trigger -->
    <div class="mb-8 w-full flex justify-center">
        <div class="h-11 w-[220px] max-w-full bg-gray-200 border border-gray-300 rounded-[10px]" />
    </div>

    <!-- Share section (shown in skeleton even when API may hide it — matches Petitions) -->
    <div class="w-full max-w-xl">
        <div class="h-6 w-40 bg-gray-300 rounded mx-auto mb-4" />

        <div class="grid grid-cols-4 gap-3 mb-4">
            {#each Array(4) as _}
                <div class="h-[88px] bg-gray-300 rounded-xl" />
            {/each}
        </div>

        <div class="h-4 w-4/5 max-w-md bg-gray-200 rounded mx-auto mb-3" />

        <div class="flex items-center gap-2 bg-gray-200 rounded-lg p-2">
            <div class="flex-1 h-10 bg-gray-300 rounded" />
            <div class="h-10 w-24 bg-gray-300 rounded-lg flex-shrink-0" />
        </div>
    </div>

    <!-- Navigation buttons -->
    <div class="flex flex-col sm:flex-row gap-3 mt-8 w-full max-w-xl">
        <div class="flex-1 h-12 bg-gray-300 rounded-lg" />
        <div class="flex-1 h-12 bg-gray-300 rounded-lg" />
    </div>
</div>
